import "./LocalSeoConsultantBedford.module.css";
import Header from "@/reusable_sections/Header";
import Localseo from "./sections/Localseo";
import BedfordConsultant from "./sections/BedfordConsultant";
import Bedfordmarketanalysis from "./sections/Bedfordmarketanalysis";
import Localseoservicesgrid from "./sections/Localseoservicesgrid";
import Process from "./sections/Process";
import ProfileOptimisation from "./sections/ProfileOptimisation";
import OnPageTechnicalSeo from "./sections/OnPageTechnicalSeo";
import LocalAuthority from "./sections/LocalAuthority";
import Industry from "./sections/Industry";
import Packages from "./sections/Packages";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import SeoResults from "./sections/SeoResults";
import BedfordFaq from "./sections/BedfordFaq";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantBedfordPage() {
  return <div>
      <Header />
      <Localseo />
      <BedfordConsultant />
      <Bedfordmarketanalysis />
      <Localseoservicesgrid />
      <Process />
      <ProfileOptimisation />
      <OnPageTechnicalSeo />
      <LocalAuthority />
      <Industry />
      <Packages />
      <ConsultantBenefits />
      <SeoResults />
      <BedfordFaq />
      <Consultation />
      <Footer />
    </div>;
}